/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import { ControllerRegistry } from "@ef/common-api";
import { RestApiDataController } from "@ef/backend-api";

import { Person, Group } from "@ef/feature-data";
import { LetterTemplate } from "@ef/feature-lettertemplate";
import { PrintApiController } from "@ef/components-print";

import {
    registerLoginService
} from "@ef/feature-login";

import {
    OauthRedirectLoginService
} from "@ef/backend-core";

export type LoginConfig = { apiurl?: string, loginurl?: string };

export async function initLogin({ apiurl, loginurl }: LoginConfig) { 
    const theApiUrl = apiurl || ( 
        typeof process != "undefined" ? process?.env.APISERVER_URL : "" 
    ) || "";

    if (!loginurl) {
        throw new Error("loginurl is required to initialize the login service");
    }

    registerLoginService(new OauthRedirectLoginService(theApiUrl, loginurl));
}

export function initControllers() {
    ControllerRegistry.set(
        "persons",
        (user) => new RestApiDataController<Person>(user, "/persons", "v3")
    );
    
    ControllerRegistry.set(
        "groups",
        (user) => new RestApiDataController<Group>(user, "/groups", "v3")
    );

    ControllerRegistry.set(
        "lettertemplates",
        (user) => new RestApiDataController<LetterTemplate>(user, "/lettertemplates", "v3")
    );

    
    ControllerRegistry.set(
        "printApi",
        (user) => new PrintApiController(user)
    );
}
